import { computed, makeObservable } from 'mobx'

import { stringToDate } from 'modules/core/lib/dates'
import { Model } from 'modules/core/lib/mobx-rest'

const HALF_DAY_TYPES = {
  beginning_of_day: 'beginning_of_day',
  end_of_day: 'end_of_day',
}

interface ICompanyHoliday {
  id: number
  summary: string
  description: string | null
  date: string
  half_day: string | null
  location_id: number
}

class CompanyHoliday extends Model<ICompanyHoliday> {
  static HalfDayTypes = HALF_DAY_TYPES

  static urlRoot() {
    return '/company_holidays'
  }

  constructor(attr: ICompanyHoliday) {
    super(attr)
    makeObservable(this, {
      parsedDate: computed,
    })
  }

  get parsedDate(): moment.Moment {
    return stringToDate(this.attributes.date, 'backend')
  }
}

export default CompanyHoliday
